import { Controller } from '@hotwired/stimulus'
import Modal from 'components/modal'

export default class extends Controller {
  initialize() {
    this.modalId = this._getModalIdFromTrigger(this.element)
    this.element.addEventListener("click", (event) => {
      this._openModal(event)
    })
  }

  _openModal(event) {
    const modal = document.querySelector(`#${this.modalId}`)
    if (!modal) {
      console.error(`Couldn't find modal element with id ${this.modalId} in the page`)
      return
    }

    // Only open if it's not already opened
    if (!modal.classList.contains("is-open"))
      Modal.showFromTriggerClick(this.modalId, this.element, event)
  }

  _getModalIdFromTrigger(element) {
    const value = element.dataset.modal || element.dataset.target || element.attributes["href"].value

    if (!element.dataset.modal) {
      console.warn("Quimbee: Falling back to using href or data-target attributes for ModalTrigger component, which are both deprecated. Use data-modal instead.")
      console.warn(element)
    }

    return value.replace(/^#/, "")
  }
}
